import {useEffect} from "react";
import {useLocalStorage} from "@mantine/hooks";
import {useAppDispatch} from "./app/hooks";
import {setChosenResponseType} from "./features/chat/sessionSlice";
import {useHasFunctionality} from "./features/chat/hooks/useHasFunctionality";
import {
    FunksjonalitetTilgangId,
    KAIResponseType,
    LocalStorageKeys,
} from "./types";

/**
 * One-time migration component to switch KAI Plus users from Fast to Deep response type.
 * This component can be safely removed after the migration period (e.g., a few weeks/months).
 */
export function ResponseTypeMigration() {
    const dispatch = useAppDispatch();
    const hasKaiPlus = useHasFunctionality(FunksjonalitetTilgangId.KAI_Plus);

    const [migrationCompleted, setMigrationCompleted] = useLocalStorage({
        key: LocalStorageKeys.ResponseTypeMigrationV1,
        defaultValue: false,
    });

    const [responseType, setResponseType] = useLocalStorage({
        key: LocalStorageKeys.ResponseType,
        defaultValue: KAIResponseType.Fast,
    });

    useEffect(() => {
        // Skip if migration already completed
        if (migrationCompleted) {
            return;
        }

        // Skip if user doesn't have KAI Plus access yet
        // (but don't mark as complete, so it can run when they get access)
        if (!hasKaiPlus) {
            return;
        }

        // Only migrate if user is still on Fast (respects manual changes to Deep)
        if (responseType === KAIResponseType.Fast) {
            // Update localStorage
            setResponseType(KAIResponseType.Deep);

            // Update Redux store
            dispatch(setChosenResponseType(KAIResponseType.Deep));

            console.log(
                "ResponseTypeMigration: Migrated KAI Plus user from Fast to Deep"
            );
        }

        // Mark migration as complete
        setMigrationCompleted(true);
    }, [
        migrationCompleted,
        hasKaiPlus,
        responseType,
        setResponseType,
        setMigrationCompleted,
        dispatch,
    ]);

    // Silent component - no UI
    return null;
}
